<template xmlns:v-slot="http://www.w3.org/1999/XSL/Transform">
  <div class="view">


    <v-simple-table :height="height>300?height+'px':'auto'" class="itemTable" fixed-header>
      <template v-slot:default>
        <thead>
        <tr class="ItemHead">
          <th class="text-left">รายการ</th>
          <th class="text-right">แต้ม/หน่วย</th>
          <th class="text-right d-none d-md-table-cell">คลัง</th>
          <th class="text-right">จำนวน</th>
          <th class="text-right">รวมแต้ม</th>
        </tr>
        </thead>
        <tbody class="cart-item">
        <tr v-for="(item, index) in dummyOrder.items.filter(item => item.is_start_of_promotion!==false)"
            :key="index"
            :currentIndex="index"
            :item="item"
            :items="order.items"
            class="ItemRow"
            :class="{'item-warning': item.product && item.product.item_from != order.item_from}"
        >
          <!-- NAME -->
          <td v-if="(item.is_start_of_promotion===true && [null,'S'].includes(item.promotion_type))" colspan="2"
              @click="onClickPromotion(item)">
            โปรฯ: {{ item.promotion.name }}
            <v-btn v-if="item.promotion.price_group!==order.price_group"
                   class="ml-1 pa-1 caption"
                   color="red"
                   x-small>
              กลุ่มราคาไม่ตรงกับโปรฯ => จะใช้ราคาปกติ
            </v-btn>


            <br/>
            <span style="float: right">{{ $helper.number_format(item.price_in_vat, 2, 2) }} x {{ item.promotion_qty }}  = {{
                item.quantity
              }}</span>
            {{ item.index_no }}.) {{
              (item.product ? item.product.nickname : null) ||
              item.product_code
            }}

            <div v-for="relate_item  in item.promotion_pack">
              <span style="float: right">{{
                  $helper.number_format(relate_item.price_in_vat, 2, 2)
                }} x {{ relate_item.promotion_qty }} = {{ relate_item.quantity }}</span>
              {{ relate_item.index_no }}.) {{
                (relate_item.product ? relate_item.product.nickname : null) ||
                relate_item.product_code
              }}

            </div>
          </td>
          <td v-else @click="onClickProduct(item.index_no-1)">
            {{ item.index_no }}.) {{
              (item.product ? item.product.nickname : null) ||
              item.product_code
            }}

            <v-btn
                v-if="item.product && item.product.non_over_stock && item.quantity>item.product.stock_MT * item.product.unit_prim_rate - item.product.reserve_MT"
                class="ml-1 red pa-1 caption"
                style="color: white;" x-small>
              !! สินค้าสั่งเกินสต๊อกไม่ได้
            </v-btn>
            <v-btn
                v-if="item.product && item.product.item_from != order.item_from"
                class="ml-1 red pa-1 caption"
                style="color: white;" x-small>
              สั่งข้าม บ. ไม่ได้
            </v-btn>

          </td>


          <!-- PRICE -->
          <td v-if="item.promotion_id===null || ![null,'S'].includes(item.promotion_type)"
              class="text-right pos-relative">

            <!--            <v-btn v-if="item.price_init!=item.price_in_vat" class="delta-button" outlined-->
            <!--                   tile x-small @click="swapPriceInVat(item)">-->
            <!--              <v-icon small>mdi-swap-vertical-circle-outline</v-icon>-->
            <!--            </v-btn>-->

            <v-icon class="mr-2 swap-price" style="color:violet"
                    v-if="item.price_init>0 && item.price_init!=item.price_in_vat|| item.custom && item.custom.hasOwnProperty('last_price')"
                    @click="swapPriceInVat(item)">mdi-swap-vertical-circle-outline
            </v-icon>

            <v-btn
                v-if="order.override_discounts && order.override_discounts[item.product_id] && order.override_discounts[item.product_id]['price']>0"
                class="delta-text price-text"
                outlined tile x-small @click="openPriceInVat(item,item.price_in_vat)">
              {{
                number_format(order.override_discounts[item.product_id]['price'], 2, 2)
              }}
            </v-btn>
            <v-btn
                v-else
                class="delta-text price-text"
                outlined tile x-small @click="openPointFinal(item)">
              <v-icon x-small color="orange">mdi-star</v-icon>
              {{ number_format(item.point_final || 0, 2, 2) }}
            </v-btn>


          </td>

          <!-- STOCK -->
          <td v-if="item.is_start_of_promotion===true && [null,'S'].includes(item.promotion_type)"
              class="td-stock text-right d-none d-md-table-cell"
              @click="onClickPromotion(item)">
            {{
              item.promotion ?
                  Math.floor(Promotion.calStock(item.promotion)) : '-'
            }}
          </td>
          <td v-else class="td-stock text-right title d-none d-md-table-cell" @click="onClickProduct(item.index_no-1)">
            {{
              Math.floor(item.product.stock_MT * item.product.unit_prim_rate - item.product.reserve_MT)
            }}
          </td>

          <!-- QTY -->
          <td class="text-right item-qty">
            <v-btn :loading="item._save_state==='dirty'" class="delta-button" outlined
                   tile x-small @click="onClickAddCart(item,-1)">
              <v-icon small>mdi-minus</v-icon>
            </v-btn>

            <v-btn v-if="item.is_start_of_promotion===true && [null,'S'].includes(item.promotion_type)"
                   class="delta-text delta-qty" outlined tile x-small
                   @click="openQuantity(item,item.quantity/item.promotion_qty)">
              <span class="stock-md">
                {{ number_format(item.quantity / item.promotion_qty) }} <span
                  style="font-size: 0.7em;font-weight:normal;">ชุด</span>

              </span>
            </v-btn>
            <v-btn v-else
                   :class="{red:item.product.non_over_stock && item.quantity>item.product.stock_MT * item.product.unit_prim_rate - item.product.reserve_MT}"
                   class="delta-text delta-qty"
                   outlined
                   style="position: relative" tile x-small @click="openQuantity(item,item.quantity)">
              <span class="stock-md">
                {{ number_format(item.quantity) }} <span
                  style="font-size: 0.7em;font-weight:normal;">{{ $helper.parseUnit(item.unit) }}</span>

              </span>
            </v-btn>


            <v-btn :loading="item._save_state==='dirty'" class="delta-button" outlined
                   tile x-small @click="onClickAddCart(item,1)">
              <v-icon small>mdi-plus</v-icon>
            </v-btn>
          </td>


          <!-- TOTAL -->
          <td v-if="item.is_start_of_promotion===true && [null,'S'].includes(item.promotion_type)" class="text-right"
              @click="onClickPromotion(item)">
            <span v-if="item.promotion.price_group!==order.price_group" class="red pl-2 pr-2">
              !!!
            </span>
            <span v-else>
            {{ number_format(item.promotion.total_price * item.quantity / item.promotion_qty, 2, 2) }}
            </span>

          </td>

          <td v-else-if="order.override_discounts && order.override_discounts[item.product_id] && order.override_discounts[item.product_id]['price']>0"
              style="color: green" class="text-right" @click="onClickProduct(item.index_no-1)">{{
              number_format(item.quantity * order.override_discounts[item.product_id]['price'], 2, 2)
            }}
          </td>
          <td v-else class="text-right" @click="onClickProduct(item.index_no-1)">
            <v-icon x-small color="orange">mdi-star</v-icon>
            {{ number_format(item.total_point || 0, 2, 2) }}
          </td>

        </tr>
        <tr>
          <td style="border-bottom: none">
            <v-btn class="primary add-product"
                   @click.stop="onClickAddItem()">เพิ่มสินค้า
            </v-btn>
          </td>
        </tr>

        <tr v-if="dummyOrder.dynamicPromotionItems && dummyOrder.dynamicPromotionItems.length>0">
          <td colspan="8" style="height: 20px;color: darkorange">
            โปรโมชั่น
          </td>
        </tr>
        <tr v-for="(item, index) in dummyOrder.dynamicPromotionItems"
            :key="'d'+index"
            :currentIndex="index"
            :item="item"
            :items="order.dynamicPromotionItems"
            class="ItemRow"
        >
          <!-- NAME -->
          <td class="d-none d-md-table-cell" colspan="1" @click="onClickPromotion(item)">
            {{ item.is_start_of_promotion ? item.promotion.name : '' }}

          </td>

          <!-- INTERNAL DISCOUNT PERCENT -->
          <td class="d-md-table-cell" colspan="5" style="max-width: 300px">
            <div class="d-md-none">
              {{ item.is_start_of_promotion ? item.promotion.name : '' }}
            </div>
            <div class="promotion-selector"
                 v-if="item.promotion && item.promotion.product_promotions.filter(p => p.promotion_type == 'F').length>1">

              <v-select v-if="item.is_start_of_promotion"
                        v-model="item.product_id"
                        :items="item.promotion.product_promotions.filter(p => p.promotion_type == 'F')"
                        hide-details
                        item-value="product_id"
                        label="แลก/แถม"
                        single-line
                        required
                        item-disabled="is_child"
                        @change="onChangePromotion(index)"
              >
                <template v-slot:selection="{ item }">
                  {{
                    (item.product ? item.product.nickname : null) ||
                    item.product_code
                  }}
                </template>
                <template v-slot:item="{ item }">
                  {{ item.is_child ? '└ ' : '' }}
                  {{
                    (item.product ? item.product.nickname : null) ||
                    item.product_code
                  }}
                  x{{ item.quantity }}
                </template>
              </v-select>
              <div v-else>
                └ {{
                  (item.product ? item.product.nickname : null) ||
                  item.product_code
                }}
              </div>

            </div>
            <div class="promotion-selector" v-else @click="onClickPromotion(item)">
              {{
                (item.product ? item.product.nickname : null) ||
                item.product_code
              }}
            </div>

            <span class="d-md-none promotion-mobile-qty">
                {{ number_format(item.quantity) }} <span
                style="font-size: 0.7em;font-weight:normal;">{{ $helper.parseUnit(item.unit) }}</span>
              </span>
            <span class="d-md-none promotion-mobile-total">
              <v-icon x-small color="orange">mdi-star</v-icon>
              {{ number_format(item.total_point || 0, 2, 2) }}
            </span>

          </td>


          <!-- QTY -->
          <td class="d-none d-md-table-cell text-right item-qty">

              <span class="stock-md">
                {{ number_format(item.quantity) }} <span
                  style="font-size: 0.7em;font-weight:normal;">{{ $helper.parseUnit(item.unit) }}</span>
              </span>

          </td>

          <!-- TOTAL -->
          <td class="d-none d-md-table-cell text-right" @click="onClickPromotion(item)">
            <span>
              <v-icon x-small color="orange">mdi-star</v-icon>
              {{ number_format(item.total_point || 0, 2, 2) }}
            </span>
          </td>
        </tr>

        </tbody>
      </template>
    </v-simple-table>


  </div>

</template>
<style lang="scss" scoped>
/*.list-container {*/
/*.list-row {*/
/*position: relative;*/
/*height: auto;*/
/*}*/
/*.list-row {*/
/*font-size: 20px;*/
/*}*/
/*@media all and (max-width: 599px) {*/
/*.list-row {*/
/*font-size: 16px;*/
/*}*/
/*}*/
/*@media all and (min-width: 600px) and (max-width: 720px) {*/
/*.list-row {*/
/*font-size: 18px;*/
/*}*/
/*}*/
/*@media all and (min-width: 720px) and (max-width: 960px) {*/
/*.list-row {*/
/*font-size: 20px;*/
/*}*/
/*}*/
/*}*/
.delta-button {
  min-width: 32px !important;
  width: 32px !important;
  height: 32px !important;
  margin: 0 4px 0;
}

.delta-text {
  height: 32px !important;
  font-weight: bold;
  font-size: 16px;
  line-height: 1;
  padding: 0 !important;
  width: 82px;
}

.price-text {
  width: 96px;
  text-align: right;
}

.ItemHead {
  th {
    /*font-size: 16px ;*/
  }
}

.ItemRow {
  cursor: pointer;

  td {
    /*font-size: 16px ;*/
  }
}

.view {
  /*background: #0000fF;*/
  width: 100%;
  display: block;
  color: #FFFFFF;
}

@media (min-height: 700px) {
  .view {
    margin-top: 150px;
    margin-bottom: 150px;
  }
}

.stock-sm {
  display: none;
}

@media (max-height: 700px) {
  .data-qty {

  }
  .stock-sm {
    display: block;
    position: absolute;
    top: -5px;
    left: -8px;
    font-weight: normal;
    font-size: 10px;
  }

  .stock-md {
    /*padding-top: 2px;*/
  }
}

.add-product {
  width: 200px;
}

.cart-item {
  td {
    padding: 0 4px;
  }

  td.item-qty {
    min-width: 170px;
    padding: 0;
  }

  td:first-child {
    padding-left: 16px;
  }

  td:last-child {
    padding-right: 16px;
  }
}

.text-strike {
  text-decoration: line-through;
}

.text-override-price {
  color: green;
  font-size: 16px;
  font-weight: bold;;
}

.pos-relative {
  position: relative;
}

.swap-price {
  position: absolute;
  left: -21px;
  top: 11px;
}

.promotion-selector .v-text-field {
  padding-top: 0;
  margin-top: 0;
}

@media (max-width: 959px) {
  .delta-text {
    width: 65px;
  }
  .promotion-selector {
    width: calc(100vw - 240px);
    display: inline-block;
  }

  .promotion-mobile-qty {
    display: inline-block;
    width: 100px;
    text-align: right;
  }

  .promotion-mobile-total {
    display: inline-block;
    width: 100px;
    text-align: right;

  }

}

.item-warning {
  //background: red;
  animation: warning-animate 1s infinite;
}

@keyframes warning-animate {
  0%, 100% {
    background-color: white;
  }
  50% {
    background-color: #e59999;
  }
}


</style>

<script lang="ts">
import {Item} from '@/models/Item'
import {Order} from '@/models/Order'
import {ProductPromotion} from '@/models/ProductPromotion'
import {Promotion} from '@/models/Promotion'
import {Component, Prop, Vue} from 'vue-property-decorator'
import ItemEditRow from '../../components/Order/ItemEditRow.vue'
import CalculatorDialog from '../../dialogs/CalculatorDialog.vue'
import router from '../../router'
import Helper from '../../services/Helper.js'

@Component({
  components: {
    CalculatorDialog,
    ItemEditRow

  }
})
export default class BodyPoint extends Vue {
  @Prop(Number) readonly height: number | undefined
  // @Prop() readonly order: Order
  @Prop() readonly dummyOrder: Order

  number_format = Helper.number_format

  Promotion = Promotion
  calObj: Item = new Item()
  calKey: string = ''

  // openCal(product, quantity) {
  //   console.log('$emit', 'openCalculator')
  //   this.$root.$emit('openCalculator', {
  //     number: quantity, onApply: (number) => {
  //       const delta = number - quantity
  //       this.$store.dispatch('alter_item_to_cart', {product, delta})
  //     },
  //   })
  // }
  order: Order = new Order()

  mounted() {
    this.order = this.$store.state.carts.current
  }

  async openQuantity(item: Item, quantity) {
    console.log('$emit', 'openCalculator')
    this.$root.$emit('openCalculator', {
      number: quantity, onApply: async (number) => {

        if (item.is_start_of_promotion) {
          if (item.promotion_qty) {
            item.quantity = item.promotion_qty * number
            await this.$store.dispatch('set_item', item)
            for (let i in item.promotion_pack) {
              let relate_item = item.promotion_pack[i]
              relate_item.quantity = relate_item.promotion_qty * number
              await this.$store.dispatch('set_item', relate_item)
            }
          }

        } else {


          let quantity = item.quantity
          if (quantity == null) quantity = 0
          const delta = number - quantity

          if (item.discount_internal_amount != null) {
            let discount_internal_amount = item.discount_internal_amount
            let discount_internal_per_item = discount_internal_amount / quantity
            item.discount_internal_amount += discount_internal_per_item * delta

          }
          if (item.discount_external_amount != null) {
            let discount_external_amount = item.discount_external_amount
            let discount_external_per_item = discount_external_amount / quantity
            item.discount_external_amount += discount_external_per_item * delta
          }

          if (item.quantity == null) {
            item.quantity = delta
          } else {
            item.quantity += delta
          }

          await this.$store.dispatch('set_item', item)
        }

        this.forceUpdate()
      }
    })
  }

  async openPriceExVat(item: Item, price_ex_vat) {
    console.log('$emit', 'openCalculator')
    const vat_percent = this.order.vat_percent ? this.order.vat_percent : 0

    this.$root.$emit('openCalculator', {
      number: price_ex_vat, onApply: async (number) => {
        item.price_ex_vat = number
        item.price_in_vat = Math.round(number * (1.00 + vat_percent / 100) * 100) / 100.0
        // item._save_state = 'dirty'
        await this.$store.dispatch('set_item', item)
        // item._save_state = ''
        this.forceUpdate()
      }
    })
  }

  async swapPriceInVat(item: Item) {
    const vat_percent = this.order.vat_percent ? this.order.vat_percent : 0

    const init = item.price_init
    if (item.price_in_vat == init && item.custom && item.custom.hasOwnProperty('last_price')) {
      item.price_in_vat = item.custom['last_price']
    } else {
      // item.price_init = item.price_in_vat
      item.price_in_vat = init
    }
    item.price_ex_vat = Math.round(init / (1.00 + vat_percent / 100) * 100) / 100.0

    // item._save_state = 'dirty'
    await this.$store.dispatch('set_item', item)
    // item._save_state = ''
    this.forceUpdate()
  }

  async openPriceInVat(item: Item, price_in_vat) {
    console.log('$emit', 'openCalculator')
    const vat_percent = this.order.vat_percent ? this.order.vat_percent : 0

    this.$root.$emit('openCalculator', {
      number: price_in_vat, onApply: async (number) => {
        item.price_in_vat = number
        item.price_ex_vat = Math.round(number / (1.00 + vat_percent / 100) * 100) / 100.0
        // item._save_state = 'dirty'
        await this.$store.dispatch('set_item', item)
        // item._save_state = ''
        this.forceUpdate()
      }
    })
  }

  async openPointFinal(item: Item) {
    console.log('$emit', 'openCalculator for point_final')

    this.$root.$emit('openCalculator', {
      number: item.point_final || 0, onApply: async (number) => {
        item.point_final = number
        await this.$store.dispatch('set_item', item)
        this.forceUpdate()
      }
    })
  }


  // applyCal(number) {
  //   console.log('applyCal', number)
  //   if (this.calKey == 'quantity') {
  //     if (this.calObj.quantity == null)
  //       this.calObj.quantity = 0
  //     const delta = number - this.calObj.quantity
  //
  //     console.log('delta', delta)
  //     //   if (this.calObj != null) {
  //     //     if (this.calObj.product != null) {
  //     //       const product = this.calObj.product
  //     //       if (this.$store.state.carts.current.id) {
  //     //         this.$store.dispatch('alter_item_to_cart', {product, delta})
  //     //       }
  //     //     }
  //     //   }
  //   }
  // }

  async onClickProduct(index) {

    await this.$store.commit('dialog_is_item_point', {toggle: true, index: index})

    // this.order.items[index]._save_state = 'saved'
  }

  async onClickPromotion(item: Item) {
    //console.log(item)
    this.$root.$emit('openPromotion', {id: item.promotion_id})
  }

  onClickAddItem() {
    router.push('/product')
  }

  async onChangePromotion(index: number) {
    // console.log(index)
    let item: Item = this.dummyOrder.dynamicPromotionItems[index]

    if (item.promotion && item.promotion.product_promotions) {
      let productPromotion: ProductPromotion = item.promotion.product_promotions
          .filter(p => p.promotion_type == 'F' && p.product_id == item.product_id)[0]

      console.log('Product id ' + item.product_id)
      if (productPromotion.product)
        console.log('Product name ' + productPromotion.product.name)

      await this.$store.dispatch('set_promotion', {index: index, productPromotion: productPromotion})
    }

    // dynamicItem.product_id = freeItem.product_id
    // dynamicItem.product = freeItem.product
    // dynamicItem.quantity = freeItem.quantity
    // dynamicItem.total_net = freeItem.display_price * freeItem.quantity
    // dynamicItem.promotion = promotion
    // dynamicItem.promotion_id = promotion.id


  }

  async onClickAddCart(item: Item, delta = 1
  ) {


    if (item.is_start_of_promotion && [null, 'S'].includes(item.promotion_type)) {
      if (item.promotion_qty && item.quantity) {
        item.quantity = item.quantity + delta * item.promotion_qty
        await this.$store.dispatch('set_item', item)
        for (let i in item.promotion_pack) {
          let relate_item = item.promotion_pack[i]
          relate_item.quantity = relate_item.quantity + delta * relate_item.promotion_qty
          await this.$store.dispatch('set_item', relate_item)
        }
      }

    } else {

      let quantity = item.quantity
      if (quantity != null && item.discount_internal_amount != null) {
        let discount_internal_amount = item.discount_internal_amount
        let discount_internal_per_item = discount_internal_amount / quantity
        item.discount_internal_amount += discount_internal_per_item * delta

      }
      if (quantity != null && item.discount_external_amount != null) {
        let discount_external_amount = item.discount_external_amount
        let discount_external_per_item = discount_external_amount / quantity
        item.discount_external_amount += discount_external_per_item * delta
      }

      if (item.quantity == null) {
        item.quantity = delta
      } else {
        item.quantity += delta
      }

      // item._save_state = 'dirty'
      await this.$store.dispatch('set_item', item)
    }
    this.forceUpdate()
  }

  forceUpdate() {
    this.order = new Order()
    this.order = this.$store.state.carts.current
  }

}
</script>

